import { initializeApp } from "@firebase/app";
import { getMessaging, isSupported } from "@firebase/messaging";
import { fcmCredentials } from "./mixins/Credentials";

var firebaseConfig = {
    apiKey: fcmCredentials.apiKey,
    authDomain: fcmCredentials.authDomain,
    databaseURL: fcmCredentials.databaseURL,
    projectId: fcmCredentials.projectId,
    storageBucket: fcmCredentials.storageBucket,
    messagingSenderId: fcmCredentials.messagingSenderId,
    appId: fcmCredentials.appId,
    measurementId: fcmCredentials.measurementId
};

const app = initializeApp(firebaseConfig);

// const messaging = getMessaging(app);


let messaging = isSupported().then((supported) => {
  if (supported) {
    return messaging = getMessaging(app);
    // Initialize FCM features...
  } else {
    console.warn("FCM not supported in this browser.");
  }
});

export { messaging };